import { ServicePaymentPuroStore } from './service-payment-puro.store';
import { Component, computed, effect, inject, input, viewChildren } from '@angular/core';
import { NumberInputComponent } from '../../../kit/input/text-input/number-input.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { SwitchInputComponent } from '../../../kit/input/switch-input/switch-input.component';
import { CheckInputComponent } from '../../../kit/input/check-input/check-input.component';
import { FormGroup } from '@angular/forms';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { getPaymentInfoFrag, puroSettingFrag } from './service-payment-puro.query';

@Component({
    selector: 'app-service-payment-puro',
    templateUrl: './service-payment-puro.component.html',
    styleUrl: './service-payment-puro.component.scss',
    providers: [ServicePaymentPuroStore],
    imports: [
        NumberInputComponent,
        Tooltip,
        TranslatePipe,
        SwitchInputComponent,
        CheckInputComponent,
    ],
})
export class ServicePaymentPuroComponent {

    public readonly store = inject(ServicePaymentPuroStore);

    public form = input<FormGroup>();
    public paymentId = input<number | null>(null);
    public formChange = input<any>();

    protected readonly prefix = 'service.payments.puro.';

    protected coefficients = computed(() => this.store.data.getPuroSetting()?.coefficients?.map((it) => it.name) || []);
    protected coefficientChecks = viewChildren<CheckInputComponent>('coefficientCheck');

    constructor() {
        effect(() => {
            const value = this.formChange();
            if (!value || !value.payment || !value.clients || value.direct) return;

            this.form()?.patchValue({
                puroRef: Math.round(value.payment / value.clients),
            }, { emitEvent: false });
        });

        effect(async () => {
            if (!this.paymentId()) return;

            const payments = await this.store.api.getServicePayments(FilterBuilder.filterById(this.paymentId()!), getPaymentInfoFrag);
            const date = new Date(payments?.items?.[0]?.validFrom || new Date());

            this.store.api.getPuroSetting({ id: date.getFullYear() }, puroSettingFrag);
        });

        effect(() => {
            const checks = this.coefficientChecks();
            const values = this.formChange();
            if (!checks || !values) return;

            const checked = new Set(values.coefficients || []);
            checks.forEach((it) => {
                it.setSelected(checked.has(it.attributes().name));
            });
        });
    }

    protected setCoefficient(name: string, value?: boolean): void {
        const checked = new Set(this.form()?.value.coefficients || []);
        if (value) {
            checked.add(name);
        } else {
            checked.delete(name);
        }

        this.form()?.patchValue({
            coefficients: Array.from(checked),
        }, { emitEvent: false });
    }

}
